import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useUpdateEffect } from '@cian/react-utils';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import { generateDataTestId } from '../../../../internal/utils';
import { CalendarPickerHeader } from './CalendarPickerHeader';
import { DayPicker } from './DayPicker';
import { YearPicker } from './YearPicker';
import { ECalendarPickerPage } from './types';
import { useCurrentDate } from './hooks';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CalendarPicker(_ref) {
  var selected = _ref.selected,
    onChange = _ref.onChange,
    min = _ref.min,
    max = _ref.max,
    dataTestId = _ref.dataTestId;
  var _useCurrentDate = useCurrentDate(selected, min, max),
    _useCurrentDate2 = _slicedToArray(_useCurrentDate, 2),
    currentDate = _useCurrentDate2[0],
    setCurrentDate = _useCurrentDate2[1];
  var _React$useState = React.useState(ECalendarPickerPage.Month),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    page = _React$useState2[0],
    setPage = _React$useState2[1];
  var contentRef = React.useRef(null);
  var dayPickerRect = React.useRef({});
  useUpdateEffect(function () {
    setCurrentDate(selected || new Date());
  }, [selected], React.useEffect);
  React.useEffect(function () {
    var contentElement = contentRef.current;
    if (!contentElement) {
      return;
    }
    var rect = contentElement.getBoundingClientRect();
    dayPickerRect.current = {
      width: rect.width,
      height: rect.height
    };
  }, []);
  var handleChangeCurrentYear = function handleChangeCurrentYear(nextYear) {
    var nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setFullYear(nextYear);
    setCurrentDate(nextCurrentDate);
    setPage(ECalendarPickerPage.Month);
  };
  var handleChangeYearClick = function handleChangeYearClick() {
    setPage(function (page) {
      return page === ECalendarPickerPage.Year ? ECalendarPickerPage.Month : ECalendarPickerPage.Year;
    });
  };
  var handlePrevMonthClick = function handlePrevMonthClick() {
    var nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(nextCurrentDate.getMonth() - 1);
    setCurrentDate(nextCurrentDate);
  };
  var handleNextMonthClick = function handleNextMonthClick() {
    var nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(nextCurrentDate.getMonth() + 1);
    setCurrentDate(nextCurrentDate);
  };
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: function onClose() {},
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['calendar-picker'],
      "data-testid": dataTestId,
      children: [/*#__PURE__*/_jsx(CalendarPickerHeader, {
        current: currentDate,
        min: min,
        max: max,
        page: page,
        onChangeYearClick: handleChangeYearClick,
        onPrevMonthClick: handlePrevMonthClick,
        onNextMonthClick: handleNextMonthClick,
        dataTestId: generateDataTestId(dataTestId, ['header'])
      }), /*#__PURE__*/_jsx("div", {
        ref: contentRef,
        className: styles['content'],
        "data-testid": generateDataTestId(dataTestId, ['content']),
        children: page === ECalendarPickerPage.Month ? /*#__PURE__*/_jsx(DayPicker, {
          selected: selected,
          month: currentDate,
          onChange: onChange,
          min: min,
          max: max,
          dataTestId: generateDataTestId(dataTestId, ['days'])
        }) : /*#__PURE__*/_jsx(YearPicker, _objectSpread(_objectSpread({}, dayPickerRect.current), {}, {
          selected: currentDate.getFullYear(),
          onChange: handleChangeCurrentYear,
          min: min && min.getFullYear(),
          max: max && max.getFullYear(),
          dataTestId: generateDataTestId(dataTestId, ['years'])
        }))
      })]
    })
  });
}